export default {
	state: {
		basket: {},
		hasNotPayedOrder: false,
		toGoOrder: false,
	},

	mutations: {
		setBasket(store, payload) {
			store.basket = {...payload}
		},
		changeNotPayedOrder(store, payload) {
			store.hasNotPayedOrder = payload
		},
		changeToGoOrder(store, payload) {
			store.toGoOrder = payload
		},
	},

	actions: {
		addItemInBasket({commit, getters}, item) {
			let basket = getters.basket
			basket[item.id] = {
				item: item,
				quantity: 1
			}
			commit('setBasket', basket)
		},

		increaseItemInBasket({commit, getters}, item_id) {
			let basket = getters.basket
			basket[item_id].quantity += 1
			commit('setBasket', basket)
		},
		
		reduceItemFromBasket({commit, getters}, item_id) {
			let basket = getters.basket
			if (basket[item_id].quantity != 1) {
				basket[item_id].quantity -= 1
			} else {
				delete basket[item_id]
			}
			commit('setBasket', basket)
		},
		
		deleteItemFromBasket({commit, getters}, item_id) {
			let basket = getters.basket
			delete basket[item_id]
			commit('setBasket', basket)
		},

		async uploadBasket({commit, getters, dispatch}) {
			let uploadData = {
				slot: getters.selectedSlot,
				dishes: getters.basketForUpload,
				is_to_go: getters.toGoOrder,
				delivery_area: getters.selectedDeliveryArea,
			}
			try {
				await dispatch('apiGuestRequest', { method: 'POST', endpoint: '/invoice/', body: uploadData })
				commit('setBasket', {})
			} catch (e) {
				if (e.response.data.error_code == 506) {
					commit('changeNotPayedOrder', true)
				}
				throw e
			}
		},

		async cancleAllOrders({commit, dispatch}) {
			await dispatch('apiGuestRequest', { method: 'POST', endpoint: '/invoice/cancel_all_my' })
			commit('changeNotPayedOrder', false)
		},

		async calculateOrder({dispatch}, body) {
			return await dispatch('apiGuestRequest', { method: 'POST', endpoint: '/invoice/calculate', body: body })
		},

		async getAvailableToGoOrders({dispatch}) {
			return (await dispatch('apiGuestRequest', { method: 'GET', endpoint: '/invoice/available_to_go' })).available
		},
	},

	getters: {
		basket(store) {
			return store.basket
		},
		hasNotPayedOrder(store) {
			return store.hasNotPayedOrder
		},
		toGoOrder(store) {
			return store.toGoOrder
		},
		basketForUpload(store) {
			if (store.basket == undefined ) {
				return []
			} else {
				let result = []
				Object.values(store.basket).forEach(elem => {
					result.push({
						dish: elem.item.id,
						quantity: elem.quantity
					})
				})
				return result
			}
		}
	}
}
